import createNumberMask from 'text-mask-addons/dist/createNumberMask';

/**
 * Maska kwoty
 */
export const moneyMask = createNumberMask({
  prefix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ' ',
  allowDecimal: true,
  decimalSymbol: ','
});
